import React from 'react';
import { Helmet } from 'react-helmet';

const Experience = () => {
    return (
        <div className="innerDiv">
            <Helmet>
                <title>Rafsan Bari - Experience as a web developer</title>
                <meta name="description" content="My experience as a web developer" />
            </Helmet>
            <div class="pagetitle"><h1>Experience</h1></div>
            <h2>Coding</h2>
            <div className="skillSet">
                <div className="skillItem">Javascript</div>
                <div className="skillItem">React</div>
                <div className="skillItem">Vue</div>
                <div className="skillItem">jQuery</div> 
                <div className="skillItem">PHP</div>
                <div className="skillItem">MySQL</div>
                <div className="skillItem">REST</div>
                <div className="skillItem">HTML5</div>
                <div className="skillItem">CSS3</div>
                <div className="skillItem">Bootstrap</div>
            </div>
            <h2>Tools & Technologies</h2>
            <div className="skillSet">
                <div className="skillItem">Adobe Photoshop</div>
                <div className="skillItem">Apache</div>
                <div className="skillItem">Browser Stack</div>
                <div className="skillItem">Cloudflare</div>
                <div className="skillItem">cPanel</div>
                <div className="skillItem">CDN</div>
                <div className="skillItem">DNS</div>
                <div className="skillItem">Figma</div>
                <div className="skillItem">GitHub</div>
                <div className="skillItem">Google Tag Manager</div>
                <div className="skillItem">Google Analytics</div>
                <div className="skillItem">Postman</div>
                <div className="skillItem">Unbounce</div>
                <div className="skillItem">Wordpress</div>
                <div className="skillItem">WooCommerce</div>
                <div className="skillItem">WP-Engine</div>
                <div className="skillItem">Vercel</div>
                <div className="skillItem">Zapier</div>
            </div>

            <div className="exp">
                <h2>Full Stack Web Developer</h2>
                <h3>J&Y Law Firm</h3>
                <p>January 2026 - Present</p>
                <ul>
                    <li>Developed and optimized high-conversion PPC landing pages using <b>Unbounce</b>, implementing <b>A/B testing</b> frameworks to drive lead generation efficiency.</li>
                    <li>Extended functionality of custom <b>WordPress</b> themes through the implementation of <b>Advanced Custom Fields (ACF)</b> and <b>Custom Post Types</b> to meet evolving marketing requirements.</li>
                    <li>Architected Zapier-to-Salesforce automations that streamlined the intake process, eliminating manual data entry and increasing operational efficiency for the intake department.</li>
                    <li>Refined <b>Google Tag Manager (GTM)</b> configurations and implemented <b>Google Offline Conversions</b> to ensure accurate attribution and data integrity across the marketing funnel.</li>
                    <li>Restructured <b>CallRail</b> to resolve tracking conflicts, ensuring precise lead source attribution for multi-channel campaigns.</li>
                    <li>Centralized company-wide resources and internal documentation by managing a <b>Microsoft SharePoint</b> intranet.</li>          
                </ul>
            </div>
            <div className="exp">
                <h2>Web Developer</h2>
                <h3>Wilshire Law Firm</h3>
                <p>July 2021 - August 2025</p>
                <ul>
                    <li>Developed websites on <b>Wordpress</b> that are mobile friendly and follow strict <b>SEO principles</b> and <b>WCAG</b> standards.</li>
                    <li>Modified and maintained <b>React</b> websites built for headless <b>GraphCMS</b> and <b>Netlify</b></li>
                    <li>Translated design <b>mockups</b> into websites and <b>landing pages</b></li>
                    <li>Utilized <b>Custom Post Types</b> & <b>Advanced Custom Fields</b> for Wordpress</li>
                    <li>Used <b>Thrive</b> theme builder and <b>Divi</b> theme builder with <b>Divi Machine</b> for custom displays </li>
                    <li>Managed and updated website content (text, images, multimedia) to align with brand guidelines and improve user experience.</li>
                    <li>Build custom coded PPC landing pages to ensure high conversion rates and fast loading</li>
                    <li><b>Optimized website performance</b> using caching, CDNs, and performance tools </li>
                    <li>Diagnosed and debug website issues such as errors, broken links, and plugin conflicts to maintain smooth website functionality.</li>
                    <li>Leveraged Google Tag Manager, Analytics, Search Console to track web performance</li>
                    <li>Worked closely with Digital Marketing team to ensure the website effectively supported business goals, promotions, and campaigns</li>
                    <li>Implemented website security measures, monitored potential threats, and ensured regular backups to safeguard data integrity.</li>
                    <li>Utilized <b>Zapier</b> for implementing automation with <b>Salesforce</b> CRM</li>
                    <li>Setup API connections with lead gen vendors and services</li>
                    <li>Utilized Optimizely for <b>A/B Testing</b> and <b>Split Testing</b> for optimizing landing pages for best conversion.</li>
                    <li>Proved ability to work independently on multiple projects in parallel, leveraging strong time management and organizational skills to ensure timely completion of projects</li>
                </ul>
            </div>
            <div className="exp">
                <h2>Web Developer & IT</h2>
                <h3>Rent A Wheel</h3>
                <p>February 2015 - July 2021</p>
                <ul>
                    <li>Built custom coded tools for internal use that helped manage and display store items and inventories.</li>
                    <li>Coded and maintained internal company intranet utilizing custom HTML, <b>PHP</b>, <b>CSS</b> and <b>Javascript</b></li>
                    <li>Maintained operation of company website by working with external developers and marketing team. </li>
                    <li>Provide remote technical <b>support</b> to 140+ stores nationwide to ensure smooth day-to-day operation.</li>
                    <li>Managed and maintained company network/internet uptime </li>
                    <li>Resolve and manage RSSS Point of Sale System to maintain store inventory and sales record database.</li>
                    <li>Manage software for company mobile devices (iOS and Android)</li>
                </ul>
            </div>
            <div className="exp">
                <h2>SEO Web Developer</h2>
                <h3>Giant Partners (Freelance)</h3>
                <p>January 2018 - March 2018</p>
                <ul>
                    <li>Modified custom <b>Wordpress</b> themes to client specifications</li>
                    <li>Corrected newly acquired client websites of errors and validation</li>
                    <li>Supported <b>SEO</b> team to <b>optimize</b> website for improving search results by using <b>Google Search Console</b> (formerly known as Google Webmaster Tools)</li>
                </ul>
            </div>
            <div className="exp">
                <h2>Web Developer</h2>
                <h3>I Think An Idea (Freelance)</h3>
                <p>December 2014 - May 2015</p>
                <ul>
                    <li>Designed website structure and layout utilizing <b>Adobe Photoshop</b></li>
                    <li>Developed responsive <b>mobile friendly</b> Wordpress websites for industrial clients</li>
                    <li>Built custom fee calculation tools for being used on client websites</li>
                    <li>Implemented dedicated mobile sites to existing sites that were not optimized for mobile devices</li>
                    <li>Worked with SEO results by <b>optimizing</b> websites with the help of Google Search Console (formerly known as Google Webmaster Tools)</li>
                </ul>
            </div>
            <div className="exp">
                <h2>Front End Web Developer</h2>
                <h3>Milestone SEO</h3>
                <p>July 2011 - August 2014</p>
                <ul>
                    <li>Develop hand coded websites by slicing <b>Photoshop</b> designs</li>
                    <li>Custom build <b>Wordpress</b> themes, layouts and UI</li>
                    <li>Optimize site compatibility for <b>Google</b>, <b>Bing</b> and <b>Yahoo</b> through the use of <b>sitemaps</b>, <b>robots</b> and <b>Webmaster Tools</b></li>
                    <li>Evaluate and debug code to ensure validity, compatibility to meet current web standards of computers and mobile devices.</li>
                    <li>Ensure <b>browser compatibility</b> for all sites built and add custom CSS when necessary</li>
                    <li>Utilize <b>jQuery</b> Mobile framework to develop and improve interactivity between user and UI</li>
                    <li>Setup and manage website domain names and hosting through the use of <b>Cpanel</b> and <b>WHM</b></li>
                    <li>Work with SEO team to enhance search performance by utilizing <b>Schema</b></li>
                    <li>Build landing pages for Pay Per Click campaigns and increase conversions</li>
                </ul>
            </div>           
        </div>
    )
}

export default Experience;